"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyHardCopyDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_policy_hard_copy_entity_1 = require("./opportunity-policy-hard-copy.entity");
const look_up_entity_1 = require("./look-up.entity");
let PolicyHardCopyDocumentMap = class PolicyHardCopyDocumentMap {
};
exports.PolicyHardCopyDocumentMap = PolicyHardCopyDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyHardCopyDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_hard_copy_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyHardCopyDocumentMap.prototype, "policyHardCopyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyHardCopyDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyHardCopyDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_policy_hard_copy_entity_1.OpportunityPolicyHardCopy, (policyHardCopy) => policyHardCopy.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "policy_hard_copy_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Relation !== "undefined" && Relation) === "function" ? _a : Object)
], PolicyHardCopyDocumentMap.prototype, "policyHardCopy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, (lookup) => lookup.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Relation !== "undefined" && Relation) === "function" ? _b : Object)
], PolicyHardCopyDocumentMap.prototype, "documentType", void 0);
exports.PolicyHardCopyDocumentMap = PolicyHardCopyDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_hard_copy_document_map")
], PolicyHardCopyDocumentMap);
